import * as bulkEndpoints from './bulk';
import * as idEndpoints from './id';
import { bulk, id, root } from './media';

export const media = {
  ...root,
  bulk: {
    ...bulk,
    ...bulkEndpoints,
  },
  id: {
    ...id,
    ...idEndpoints,
  },
};
